"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Controller_1 = require("../Controller");
var GroupErrorCodes_1 = require("../../components/Group/Context/ErrorHandler/GroupErrorCodes");
var ErrorHandlerController = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorHandlerController, _super);
    function ErrorHandlerController(controllerConfig, groupId) {
        var _this = _super.call(this, controllerConfig, groupId) || this;
        _this.initError = groupId ? null : GroupErrorCodes_1.GroupErrorCodes.GROUP_404;
        return _this;
    }
    ErrorHandlerController.prototype.pageReady = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setState({
                    groupErrorCode: this.initError,
                    errorHandlers: {
                        goToGroupList: this.goToGroupList,
                    },
                });
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    return ErrorHandlerController;
}(Controller_1.Controller));
exports.ErrorHandlerController = ErrorHandlerController;
//# sourceMappingURL=ErrorHandlerController.js.map